import Swiper, { Pagination, Navigation } from 'swiper';
import { ProductMedia } from 'Modules/productMedia';
Swiper.use([Pagination, Navigation]);

// @ts-ignore
let module: any = {};

/**
 * Instantiate Vue Application
 */
module.setupAddThis = () => {
    // Set the share link to set up for Add This for the large image
    // let addThisCompactButton = document.querySelectorAll('.addthis_button_compact');
    //
    // addThisCompactButton.forEach((button) => {
    // 	button.setAttribute('href', 'http://api.addthis.com/oexchange/0.8/offer?url=' + fullImageUrl)
    // });
    // $('.addthis_button_compact').attr({
    // 	href:
    // });
};

module.askQuestion = () => {
    function eventFire(el, etype) {
        console.log('got inside eventfire');
        if (el.fireEvent) {
            el.fireEvent('on' + etype);
        } else {
            var evObj = document.createEvent('Events');
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
        }
    }

    $('body').on('click', '.bv_war_button', function (event) {
        event.preventDefault();
        eventFire(document.querySelector('.js-tab[data-target="#reviews"]'), 'click');
        let topPosition = document.querySelector('.js-tab[data-target="#reviews"]').getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth',
        });
    });

    $('body').on('click', '.bv_aaq_button', function (event) {
        event.preventDefault();
        eventFire(document.querySelector('.js-tab[data-target="#qas"]'), 'click');
        let topPosition = document.querySelector('.js-tab[data-target="#qas"]').getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth',
        });
    });
    $('body').on('click', '.bv_ratings_summary', function (event) {
        event.preventDefault();
        eventFire(document.querySelector('.js-tab[data-target="#reviews"]'), 'click');
        let topPosition = document.querySelector('.js-tab[data-target="#reviews"]').getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth',
        });
    });
};

module.setupSlider = () => {
    const breakpoint = window.matchMedia('(min-width:768px)');
    let fpSlider;
    // let $swiperContainer = $('.js-product-swiper-container');
    let swiperWrapper = document.querySelector('.js-product-detail-wrapper');
    let swiperSlide = document.querySelectorAll('.js-product-detail-slide');

    if (!swiperWrapper) {
        return;
    }

    const breakpointChecker = () => {
        if (breakpoint.matches === true) {
            if (fpSlider !== undefined) {
                // $swiperContainer.removeClass('swiper-container');
                swiperWrapper.classList.remove('swiper-wrapper');
                swiperSlide.forEach((slide) => {
                    slide.classList.remove('swiper-slide');
                });
                fpSlider.destroy(true, true);
            }
            return;
        } else if (breakpoint.matches === false) {
            return enableSlider();
        }
    };

    const enableSlider = () => {
        swiperWrapper.classList.add('swiper-wrapper');
        swiperSlide.forEach((slide) => {
            slide.classList.add('swiper-slide');
        });

        fpSlider = new Swiper('.js-product-detail', {
            loop: false,
            //@ts-ignore
            slidesPerView: '1',
            centeredSlides: true,
            keyboardControl: true,
            grabCursor: true,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            navigation: {
                nextEl: '.product-detail-next',
                prevEl: '.product-detail-prev',
            },
        });

        fpSlider.init();
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
};

module.setupScrollHelper = () => {
    window.addEventListener('scroll', () => {
        $('.tooltipster-base').hide();
    });
};

module.beforePrintSetup = () => {
    // Keep track of where elements lived so we can put them back after printing.
    type Place = { parent: Node; next: ChildNode | null };
    const printMoves = new Map<Node, Place>();

    // Remember an element's current spot (parent + the node that used to be after it).
    function remember(el: Node) {
        if (el.parentNode && !printMoves.has(el)) {
            printMoves.set(el, { parent: el.parentNode, next: el.nextSibling });
        }
    }

    // Move an element for print. If "before" is null, this effectively appends it.
    function moveForPrint(el: Element | null, dest: Node | null, before: ChildNode | null = null) {
        if (!el || !dest) return;
        remember(el);
        dest.insertBefore(el, before); // null => append
    }

    // Put everything back where it started.
    function restorePrintDom() {
        // Do this in reverse so siblings go back in the right order.
        const entries = Array.from(printMoves.entries());
        for (let i = entries.length - 1; i >= 0; i--) {
            const [el, { parent, next }] = entries[i];
            try {
                // Parent might have been removed; if so, just skip it.
                if (parent && (parent as any).isConnected !== false) {
                    parent.insertBefore(el, next); // null => append
                }
            } catch {
                // If something disappeared between print and now, nothing to restore here.
            }
        }
        printMoves.clear();
    }

    // What we shuffle around for the printed version.
    function handleBeforePrint() {
        const container = document.querySelector('.print-container') as HTMLElement | null;
        if (!container) return;

        const heading    = container.querySelector('h1');
        const qsEl       = container.querySelector('.product-detail__quickship');
        const finishList = container.querySelector('.product-detail__main-finish-list');
        const pfootSpecs = document.querySelector('.pfoot-specs');
        const pfoot      = document.querySelector('.pfoot');

        // Reorder pieces for print.
        moveForPrint(heading,    container, container.firstChild);
        moveForPrint(finishList, container);
        moveForPrint(pfootSpecs, container);
        moveForPrint(pfoot,      container);
        if (qsEl && heading) moveForPrint(qsEl, heading);
    }

    // And this puts the DOM back the way it was.
    function handleAfterPrint() {
        restorePrintDom();
    }

    // Real print lifecycle.
    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint',  handleAfterPrint);

    // Make DevTools “Emulate CSS media: print” run the same logic.
    const mql = window.matchMedia('print');

    // If print emulation is already on when this runs, do the print moves now.
    if (mql.matches) handleBeforePrint();

    if ('addEventListener' in mql) {
        mql.addEventListener('change', (e: MediaQueryListEvent) => {
            if (e.matches) handleBeforePrint();
            else handleAfterPrint();
        });
    } else {
        // Older browsers (Safari, older Chromium).
        // @ts-ignore
        mql.addEventListener((e: MediaQueryList) => {
            if (e.matches) handleBeforePrint();
            else handleAfterPrint();
        });
    }
};




module.init = function () {
    module.setupSlider();
    module.setupScrollHelper();
    module.beforePrintSetup();
    module.askQuestion();
    ProductMedia.init();
};

if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', module.init);
} else {
    // `DOMContentLoaded` has already fired
    module.init();
}
